/**
 * @desc 更新
 */
const URL = "/rantion-bus";
import http, { updateResponse } from "@/http";
export function request(body: defs.bus.SystemConfigRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/systemConfig/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
